import React from "react";
// import Footer from "./Footer";
import Navbar from "../landing/Navbar";
import Chatbot from "../chatbot/Chatbot";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col h-screen overflow-hidden bg-white text-gray-900">
      <Navbar />
      <main className="flex-1 overflow-y-auto overflow-x-hidden relative" id="app-main-content">
        {children}
      </main>
      {/* Always render chatbot; component itself will hide if user is not
          authenticated (checks localStorage token). */}
      <Chatbot />
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;
